<template>


    <div class="ask-for-quote--header">
        <card class="card--message error" v-if="!this.askForQuote.client_user.is_checked">
            <card-content>
                <strong>Kunde nicht geprüft: <a :href="clientUser" target="_blank"
                                                v-if="clientUser">Kundendaten</a></strong>
            </card-content>
        </card>

        <description-group>
            <description-element :caption="askForQuote?.pfnumber" title="PF-Nr."/>
            <description-element
                :caption="askForQuote?.client_user.client_no + ' - ' + askForQuote?.client_user.company"
                title="Kundennr"/>
            <description-element :caption="producerUser" title="Produzentennr."/>
            <description-element :caption="readableStatus" title="Status"/>
            <description-element :caption="askForQuote?.created_at" isDate="1" title="Anfragedatum"/>
            <description-element :caption="askForQuote?.client_order?.created_at" isDate="1" title="Auftragsdatum"/>
            <description-element :caption="askForQuote?.producer_order?.planned_production_start_at" isDate="1"
                                 title="geplanter Produktionsstart"/>
            <description-element :caption="askForQuote?.delivery_date" isDate="1" title="Wunschliefertermin"/>
            <description-element :caption="deliveryDate" title="Lieferdatum"/>
        </description-group>

        <menu-tabs :askForQuoteId="askForQuote?.id" :askForQuoteStatus="askForQuote?.status"/>


    </div>
</template>

<script>
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import MenuTabs from '../Tabs/MenuTabs';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import CardContent from '@partfactory/Shared/Card/CardContent';
import Card from '@partfactory/Shared/Card/Card';

export default {
    name: 'AskForQuoteHeader',
    components: {Card, CardContent, DescriptionElement, MenuTabs, DescriptionGroup},
    props: {
        'askForQuote': Object,
    },
    computed: {
        readableStatus() {
            let status = this.$page.props.askForQuoteStatus.filter((status) => {
                return status.status_id === String(this?.askForQuote?.status);
            });
            return status[0]?.status_name;
        },
        deliveryDate() {
            return this.askForQuote?.client_late_delivery?.new_delivery_date ? this.$date(this.askForQuote?.client_late_delivery?.new_delivery_date) + ' (korrigiert)' : this.$date(this.askForQuote?.client_order?.delivery_at);
        },
        clientUser() {
            return this.askForQuote.client_user ? this.$$route('client-user.edit', {'clientUser': this.askForQuote.client_user.id}) : null;
        },
        producerUser() {
            return this.askForQuote?.producer_order?.producer_user?.prod_no ? this.askForQuote?.producer_order?.producer_user?.prod_no + ' - ' + this.askForQuote?.producer_order?.producer_user?.company : '-';
        }
    },
};
</script>
